(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('BulkFieldsCtrl', BulkFieldsCtrl);

  /** @ngInject */
  function BulkFieldsCtrl($templateCache, $window, sessionService, $rootScope, $scope, $filter, $document, $state, $uibModal, maps, NgTableParams, Parcels, tracts) {
    let vm = this;
    vm.bulkFields = [];
    vm.bulkRow = {};
    vm.keydownNumber = 0;
    vm.textAreaLength = 0;
    // bulk editablefields
    let allBulkFields = [{
      'name': 'Forfeiture Date',
      'value': 'Forfeiture_date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Tax Forfeit Status',
      'value': 'TaxForfeitedStatus',
      'type': 'select'
    }, {
      'name': 'Board Class Action',
      'value': 'Board_Class_Action',
      'type': 'select'
    }, {
      'name': 'Board Class Action Date',
      'value': 'BoardClassAction_Date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Notice Sent to the City',
      'value': 'Notice_Date_TwpCity_Class',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Notice Sent to DNR',
      'value': 'Notice_Date_DNR_Class',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'City Response',
      'value': 'CityTwpResponse',
      'type': 'select'
    }, {
      'name': 'DNR Response',
      'value': 'DNRResponse',
      'type': 'select'
    }, {
      'name': 'City Response Date',
      'value': 'CityTwpResponse_Date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'DNR Response Date',
      'value': 'DNRResponse_Date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Resolution Sent to DNR',
      'value': 'ResolutionSentToDNR',
      'type': 'select'
    }, {
      'name': 'DNR Resolution Date',
      'value': 'ResolutionDateToDNR',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Judgement Year',
      'value': 'Judgement_Year',
      'type': 'input'
    }, {
      'name': 'Purchase Price',
      'value': 'Purch_price',
      'type': 'input'
    }, {
      'name': 'Repurchase Price',
      'value': 'Repurch_price',
      'type': 'input'
    }, {
      'name': 'Original Land Sale Date',
      'value': 'Origin_LS_Date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Office Classification',
      'value': 'Office_Classification',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Auction Date',
      'value': 'Last_LS_date',
      'type': 'date',
      'date': '',
      'open': false
    }, {
      'name': 'Proposed Sale Type',
      'value': 'ProposedSaleType',
      'type': 'select'
    }, {
      'name': 'Sold Type',
      'value': 'Sold_type',
      'type': 'select'
    }, {
      'name': 'Purchased Date',
      'value': 'PurchaseDate',
      'type': 'date',
      'date': '',
      'open': false
    }];

    // watch for the bulk field list change
    $scope.$on('bulkfields-changed', function(event, data) {
      vm.bulkFields = _filterByFieldValue(data);
      // console.log('filtered list: ', vm.bulkFields);
    });

    // date format
    vm.dateFormat = 'MM/dd/yyyy';

    // date picker open/closed forfeiture date
    vm.fStartDate = {
      date: null,
      open: false
    };

    vm.dateOptions = {
      //dateDisabled: disabled,
      formatYear: 'yyyy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    // open and close the forfeiture date pickers
    vm.fOpenStart = function(item) {
      item.open = true;
    };

    vm.fOpenEnd = function() {
      vm.fEndDate.open = true;
    };

    // open and close the forfeiture date pickers
    vm.fBulkStart = function() {
      vm.date.open = true;
    };

    vm.updateAll = function() {
      let modalInstance = $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/confirm.tpl.html'),
        controller: 'ConfirmDialogCtrl',
        size: 'sm',
        resolve: {
          message: function() {
            return 'Edits will apply to parcels and tracts. Are you sure you want to update fields with the selected values?';
          },
          showWarning: function() {
            return true;
          }
        }
      });

      modalInstance.result.then(function() {
        _updateAllParcels(vm.bulkRow);
      });
    };

    function _updateAllParcels(bulkRow) {
      // pass over the update field and the list of check boxes
      let searchType = Parcels.getSearchType();
      if (searchType === 'parcels') {
        Parcels.updateAll(bulkRow, vm.checkeditems, 'PIN');
      } else if (searchType === 'tracts') {
        Parcels.updateAll(bulkRow, vm.checkeditems, 'Tract').then(function(results) {
          tracts.updateAll(bulkRow, vm.checkeditems, 'Tract');
        });
      }
    }

    vm.getDomainValues = function(field) {
      return _.find(vm.fields, {
        'name': field
      }).domain.codedValues;
    };

    // vm.addKeyUp = function(e, textModal) {
    //   if (vm.bulkRow[textModal] !== undefined && vm.bulkRow[textModal] !== null) {
    //     if (typeof(vm.bulkRow[textModal]) === 'number') {
    //       if(vm.keydownNumber === vm.bulkRow[textModal]) {
    //         vm.bulkRow[textModal] = vm.bulkRow[textModal] * 10;
    //         vm.bulkRow[textModal] += parseInt(e.key);
    //       }
    //     } else if (typeof(vm.bulkRow[textModal]) === 'string') {
    //     //  console.log('up string');
    //       if(vm.textAreaLength === vm.bulkRow[textModal].length) {
    //         vm.bulkRow[textModal] += e.key;
    //       }
    //     }
    //   }else {
    //       vm.bulkRow[textModal] = e.key;
    //   }
    // };
    //
    // vm.addKeyDown = function(textModal) {
    //   if (vm.bulkRow[textModal] !== undefined && vm.bulkRow[textModal] !== null) {
    //     if (typeof(vm.bulkRow[textModal]) === 'number') {
    //       vm.keydownNumber = vm.bulkRow[textModal];
    //     } else if (typeof(vm.bulkRow[textModal]) === 'string') {
    //       vm.textAreaLength = vm.bulkRow[textModal].length;
    //     }
    //   }
    // };
    // jshint ignore:start
    function _formatDate(date) {
      return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }
    // jshint ignore:end

    function _filterByFieldValue(fields) {
      let filteredList = [];
      for (let i = 0; i < allBulkFields.length; i++) {
        if (fields.indexOf(allBulkFields[i].value) >= 0) {
          filteredList.push(allBulkFields[i]);
        }
      }
      return filteredList;
    }
  }
})();
